// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1dlt7","header":"ReportDetails_header__33Bbs","title":"ReportDetails_title__YdyBk","left":"ReportDetails_left__1FStt"};